import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { markAsRead, markAllAsRead } from "../../actions/index";
import "./notif_list.css";

import DataTable from "../../components/datatable/datatable";

class NotifsList extends Component {
  render() {
    const columns = [
      { Header: "", accessor: "id", disableFilters: true, show: false },
      { Header: window.i18n.t("notifications.headers.type"), accessor: "notifiable_type", disableFilters: true },
      { Header: window.i18n.t("notifications.headers.date"), accessor: "created_at", disableFilters: true },
      { Header: window.i18n.t("notifications.headers.from"), accessor: "author", disableFilters: true },
      { Header: window.i18n.t("notifications.headers.content"), accessor: "content", disableFilters: true },
      { Header: window.i18n.t("notifications.headers.service"), accessor: "service_name", disableFilters: true },
      { Header: window.i18n.t("notifications.headers.requestNumber"), accessor: "need_num", disableFilters: true },
      {
        Header: window.i18n.t("notifications.headers.view"),
        accessor: "show_link",
        disableFilters: true,
        clickable: true,
        Cell: ({ row }) => {
          // Create the base URL with the notification ID
          let url = row.values.show_link + `?notif=${row.values.id}`;

          // For message notifications, add tab parameter if chat_id is available
          if (row.original.notifiable_type === "Message" && row.original.chat_id) {
            // Add the chat_id as the tab parameter
            url += `&tab=${row.original.chat_id}`;
          }

          return (
            <a
              className="datatable__table__link"
              href={url}
            >
              <div className="dashboard__icon notif-list__icon--show"></div>
            </a>
          );
        }
      },
      {
        Header: "",
        accessor: "read_at",
        disableFilters: true,
        clickable: true,
        Cell: ({ row, updateMyData, updateCallback }) => {
          const handleClick = row => event => {
            updateMyData(row.index, "read_at", row.values.id, updateCallback);
          };
          return (
            <a
              className="datatable__table__link"
              onClick={handleClick(row)}
              data-toggle="tooltip"
              data-placement="bottom"
              title={window.i18n.t("notifications.markAsRead")}
            >
              <div
                className={`notif-list__icon notif-list__icon--notif notif-list__icon--notif${
                  row.values.read_at ? null : "--not-"
                }read`}
              ></div>
            </a>
          );
        }
      },
      {
        Header: "",
        accessor: "is_read",
        disableFilters: true,
        show: false,
        menu: [
          { val: "false", display: window.i18n.t("notifications.filters.unread") },
          { val: "true", display: window.i18n.t("notifications.filters.read") }
        ]
      }
    ];

    const lang = document.documentElement.lang || "fr";
    const data = (this.props.notifs || []).map(notif => ({
      ...notif,
      content: lang === "fr" ? notif.content_fr : notif.content_en
    }));
    const hasUnreadNotifications = data.some(notif => notif.read_at === null);

    return (
      <div>
        <div className="mark-all-button-container">
          <button
            className="mark-all-button"
            onClick={() => this.props.markAllAsRead()}
            disabled={!hasUnreadNotifications}
          >
            {window.i18n.t("notifications.markAllAsRead")}
          </button>
        </div>
        <DataTable
          columns={columns}
          data={data}
          notifs={this.props.notifs}
          updateCallback={this.props.markAsRead}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { notifs: state.notifs };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ markAsRead, markAllAsRead }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotifsList);
